<template>
  <div class="btn-list">
    <div class="left">
      <template v-for="(item,index) in leftBtnList">
        <BtnAdd :btn="item" v-if="item.btnType == 1"></BtnAdd>
        <BtnEdit :btn="item" v-else-if="item.btnType == 4"></BtnEdit>
        <BtnExcel :btn="item" v-else-if="item.btnType == 2"></BtnExcel>
        <template v-else-if="item.btnType == 5">
        <Btn :btn="item" v-if="menuList.indexOf('CD_623') != -1"></Btn>
        </template>
        <Btn :btn="item" v-else></Btn>
      </template>
    </div>
    <div class="right">
      <template v-for="(item,index) in rightBtnList">
        <BtnAdd :btn="item" v-if="item.btnType == 1"></BtnAdd>
        <BtnEdit :btn="item" v-else-if="item.btnType == 4"></BtnEdit>
        <BtnExcel :btn="item" v-else-if="item.btnType == 2"></BtnExcel>
        <Btn :btn="item" v-else></Btn>
      </template>
    </div>
  </div>
</template>
<script>
  import Btn from "@/components/list/button/btn";
  import BtnAdd from "@/components/list/button/btnAdd";
  import BtnEdit from "@/components/list/button/btnEdit";
  import BtnExcel from "@/components/list/button/btnExcel";
  export default {
    name: 'btnList',
    components: {
      Btn,
      BtnExcel,
      BtnAdd,
      BtnEdit
    },
    props: {
      btnList: {
        type: Array,
        default: []
      },
    },
    data: function() {
      return {
        leftBtnList: [],
        rightBtnList: [],
        menuList: [],
      }
    },
    methods: {
    },
    mounted() {
      var $this = this;
      this.btnList.forEach(function(item, index) {
        if (item.btnPosition == 'right') {
          $this.rightBtnList.push(item);
        } else {
          $this.leftBtnList.push(item);
        }
      })
      this.menuList = this.$store.getters.getMenuPermission;
    }
  };
</script>
<style>
   .btn-list .el-button{
     background-color: #2CBA85;
         height: 30px;
         display: flex;
         align-items: center;
         color: #fff;
         border: 0;
         border-radius:15px ;
         font-size: 16px;
   }
</style>



// WEBPACK FOOTER //
// src/components/list/btnList.vue